import * as ambassadorWixEcomV1Order from './ecom-v1-order-orders.http.js';
import * as ambassadorWixEcomV1OrderTypes from './ecom-v1-order-orders.types.js';
import * as ambassadorWixEcomV1OrderUniversalTypes from './ecom-v1-order-orders.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function preparePaymentCollection(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.PreparePaymentCollectionRequest,
  ambassadorWixEcomV1OrderTypes.PreparePaymentCollectionRequest,
  ambassadorWixEcomV1OrderUniversalTypes.PreparePaymentCollectionResponse &
    ambassadorWixEcomV1OrderUniversalTypes.PreparePaymentCollectionResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.PreparePaymentCollectionResponse &
    ambassadorWixEcomV1OrderTypes.PreparePaymentCollectionResponseNonNullableFields
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.preparePaymentCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/prepare-payment-collection',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPaymentCollectabilityStatus(): __PublicMethodMetaInfo<
  'GET',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.GetPaymentCollectabilityStatusRequest,
  ambassadorWixEcomV1OrderTypes.GetPaymentCollectabilityStatusRequest,
  ambassadorWixEcomV1OrderUniversalTypes.GetPaymentCollectabilityStatusResponse &
    ambassadorWixEcomV1OrderUniversalTypes.GetPaymentCollectabilityStatusResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.GetPaymentCollectabilityStatusResponse &
    ambassadorWixEcomV1OrderTypes.GetPaymentCollectabilityStatusResponseNonNullableFields
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.getPaymentCollectabilityStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/payments-collector/orders/{ecomOrderId}/payment-collectability-status',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function recordManuallyCollectedPayment(): __PublicMethodMetaInfo<
  'POST',
  { orderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.RecordManuallyCollectedPaymentRequest,
  ambassadorWixEcomV1OrderTypes.RecordManuallyCollectedPaymentRequest,
  ambassadorWixEcomV1OrderUniversalTypes.RecordManuallyCollectedPaymentResponse,
  ambassadorWixEcomV1OrderTypes.RecordManuallyCollectedPaymentResponse
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.recordManuallyCollectedPayment(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{orderId}/manual-payment',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function paymentCollectionMarkOrderAsPaid(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.MarkOrderAsPaidRequest,
  ambassadorWixEcomV1OrderTypes.MarkOrderAsPaidRequest,
  ambassadorWixEcomV1OrderUniversalTypes.MarkOrderAsPaidResponse &
    ambassadorWixEcomV1OrderUniversalTypes.MarkOrderAsPaidResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.MarkOrderAsPaidResponse &
    ambassadorWixEcomV1OrderTypes.MarkOrderAsPaidResponseNonNullableFields
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.paymentCollectionMarkOrderAsPaid(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/mark-as-paid',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function paymentCollectionBulkMarkOrdersAsPaid(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.BulkMarkOrdersAsPaidRequest,
  ambassadorWixEcomV1OrderTypes.BulkMarkOrdersAsPaidRequest,
  ambassadorWixEcomV1OrderUniversalTypes.BulkMarkOrdersAsPaidResponse &
    ambassadorWixEcomV1OrderUniversalTypes.BulkMarkOrdersAsPaidResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.BulkMarkOrdersAsPaidResponse &
    ambassadorWixEcomV1OrderTypes.BulkMarkOrdersAsPaidResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.paymentCollectionBulkMarkOrdersAsPaid(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/payments-collector/mark-as-paid',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRefundabilityStatus(): __PublicMethodMetaInfo<
  'GET',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.GetRefundabilityStatusRequest,
  ambassadorWixEcomV1OrderTypes.GetRefundabilityStatusRequest,
  ambassadorWixEcomV1OrderUniversalTypes.GetRefundabilityStatusResponse &
    ambassadorWixEcomV1OrderUniversalTypes.GetRefundabilityStatusResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.GetRefundabilityStatusResponse &
    ambassadorWixEcomV1OrderTypes.GetRefundabilityStatusResponseNonNullableFields
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.getRefundabilityStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/payments-collector/orders/{ecomOrderId}/refundability',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function paymentCollectionCreatePaymentGatewayOrder(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.CreatePaymentGatewayOrderRequest,
  ambassadorWixEcomV1OrderTypes.CreatePaymentGatewayOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.CreatePaymentGatewayOrderResponse &
    ambassadorWixEcomV1OrderUniversalTypes.CreatePaymentGatewayOrderResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.CreatePaymentGatewayOrderResponse &
    ambassadorWixEcomV1OrderTypes.CreatePaymentGatewayOrderResponseNonNullableFields
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.paymentCollectionCreatePaymentGatewayOrder(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/create-payment-gateway-order',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function chargeMemberships(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.ChargeMembershipsRequest,
  ambassadorWixEcomV1OrderTypes.ChargeMembershipsRequest,
  ambassadorWixEcomV1OrderUniversalTypes.ChargeMembershipsResponse,
  ambassadorWixEcomV1OrderTypes.ChargeMembershipsResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.chargeMemberships(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/charge-membership',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function triggerRefund(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.TriggerRefundRequest,
  ambassadorWixEcomV1OrderTypes.TriggerRefundRequest,
  ambassadorWixEcomV1OrderUniversalTypes.TriggerRefundResponse &
    ambassadorWixEcomV1OrderUniversalTypes.TriggerRefundResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.TriggerRefundResponse &
    ambassadorWixEcomV1OrderTypes.TriggerRefundResponseNonNullableFields
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.triggerRefund(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/trigger-refund',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function voidAuthorizedPayments(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.VoidAuthorizedPaymentsRequest,
  ambassadorWixEcomV1OrderTypes.VoidAuthorizedPaymentsRequest,
  ambassadorWixEcomV1OrderUniversalTypes.VoidAuthorizedPaymentsResponse &
    ambassadorWixEcomV1OrderUniversalTypes.VoidAuthorizedPaymentsResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.VoidAuthorizedPaymentsResponse &
    ambassadorWixEcomV1OrderTypes.VoidAuthorizedPaymentsResponseNonNullableFields
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.voidAuthorizedPayments(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/void-authorized-payments',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function captureAuthorizedPayments(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.CaptureAuthorizedPaymentsRequest,
  ambassadorWixEcomV1OrderTypes.CaptureAuthorizedPaymentsRequest,
  ambassadorWixEcomV1OrderUniversalTypes.CaptureAuthorizedPaymentsResponse &
    ambassadorWixEcomV1OrderUniversalTypes.CaptureAuthorizedPaymentsResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.CaptureAuthorizedPaymentsResponse &
    ambassadorWixEcomV1OrderTypes.CaptureAuthorizedPaymentsResponseNonNullableFields
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.captureAuthorizedPayments(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/capture-authorized-payments',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOrder(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixEcomV1OrderUniversalTypes.GetOrderRequest,
  ambassadorWixEcomV1OrderTypes.GetOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.GetOrderResponse &
    ambassadorWixEcomV1OrderUniversalTypes.GetOrderResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.GetOrderResponse &
    ambassadorWixEcomV1OrderTypes.GetOrderResponseNonNullableFields
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.getOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/orders/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.SearchOrdersRequest,
  ambassadorWixEcomV1OrderTypes.SearchOrdersRequest,
  ambassadorWixEcomV1OrderUniversalTypes.SearchOrdersResponse &
    ambassadorWixEcomV1OrderUniversalTypes.SearchOrdersResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.SearchOrdersResponse &
    ambassadorWixEcomV1OrderTypes.SearchOrdersResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Order.searchOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createOrder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.CreateOrderRequest,
  ambassadorWixEcomV1OrderTypes.CreateOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.CreateOrderResponse &
    ambassadorWixEcomV1OrderUniversalTypes.CreateOrderResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.CreateOrderResponse &
    ambassadorWixEcomV1OrderTypes.CreateOrderResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Order.createOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOrder(): __PublicMethodMetaInfo<
  'PATCH',
  { orderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderRequest,
  ambassadorWixEcomV1OrderTypes.UpdateOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderResponse &
    ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.UpdateOrderResponse &
    ambassadorWixEcomV1OrderTypes.UpdateOrderResponseNonNullableFields
> {
  const payload = { order: { id: ':orderId' } } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.updateOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/orders/{order.id}',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrdersRequest,
  ambassadorWixEcomV1OrderTypes.BulkUpdateOrdersRequest,
  ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrdersResponse &
    ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrdersResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.BulkUpdateOrdersResponse &
    ambassadorWixEcomV1OrderTypes.BulkUpdateOrdersResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Order.bulkUpdateOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/orders/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function commitDeltas(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixEcomV1OrderUniversalTypes.CommitDeltasRequest,
  ambassadorWixEcomV1OrderTypes.CommitDeltasRequest,
  ambassadorWixEcomV1OrderUniversalTypes.CommitDeltasResponse &
    ambassadorWixEcomV1OrderUniversalTypes.CommitDeltasResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.CommitDeltasResponse &
    ambassadorWixEcomV1OrderTypes.CommitDeltasResponseNonNullableFields
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.commitDeltas(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/{id}/commit-deltas',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOrderLineItem(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string; lineItemId: string },
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderLineItemRequest,
  ambassadorWixEcomV1OrderTypes.UpdateOrderLineItemRequest,
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderLineItemResponse &
    ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderLineItemResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.UpdateOrderLineItemResponse &
    ambassadorWixEcomV1OrderTypes.UpdateOrderLineItemResponseNonNullableFields
> {
  const payload = { id: ':id', lineItem: { id: ':lineItemId' } } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.updateOrderLineItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/orders/{id}/line-item/{lineItem.id}',
    pathParams: { id: 'id', lineItemId: 'lineItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addActivity(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixEcomV1OrderUniversalTypes.AddActivityRequest,
  ambassadorWixEcomV1OrderTypes.AddActivityRequest,
  ambassadorWixEcomV1OrderUniversalTypes.AddActivityResponse &
    ambassadorWixEcomV1OrderUniversalTypes.AddActivityResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.AddActivityResponse &
    ambassadorWixEcomV1OrderTypes.AddActivityResponseNonNullableFields
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.addActivity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/{id}/activities',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateActivity(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string; activityId: string },
  ambassadorWixEcomV1OrderUniversalTypes.UpdateActivityRequest,
  ambassadorWixEcomV1OrderTypes.UpdateActivityRequest,
  ambassadorWixEcomV1OrderUniversalTypes.UpdateActivityResponse &
    ambassadorWixEcomV1OrderUniversalTypes.UpdateActivityResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.UpdateActivityResponse &
    ambassadorWixEcomV1OrderTypes.UpdateActivityResponseNonNullableFields
> {
  const payload = { id: ':id', activityId: ':activityId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.updateActivity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/orders/{id}/activities/{activityId}',
    pathParams: { id: 'id', activityId: 'activityId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteActivity(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string; activityId: string },
  ambassadorWixEcomV1OrderUniversalTypes.DeleteActivityRequest,
  ambassadorWixEcomV1OrderTypes.DeleteActivityRequest,
  ambassadorWixEcomV1OrderUniversalTypes.DeleteActivityResponse &
    ambassadorWixEcomV1OrderUniversalTypes.DeleteActivityResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.DeleteActivityResponse &
    ambassadorWixEcomV1OrderTypes.DeleteActivityResponseNonNullableFields
> {
  const payload = { id: ':id', activityId: ':activityId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.deleteActivity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/orders/{id}/activities/{activityId}',
    pathParams: { id: 'id', activityId: 'activityId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelOrder(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixEcomV1OrderUniversalTypes.CancelOrderRequest,
  ambassadorWixEcomV1OrderTypes.CancelOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.CancelOrderResponse &
    ambassadorWixEcomV1OrderUniversalTypes.CancelOrderResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.CancelOrderResponse &
    ambassadorWixEcomV1OrderTypes.CancelOrderResponseNonNullableFields
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.cancelOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/{id}/cancel',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOrderStatus(): __PublicMethodMetaInfo<
  'POST',
  { orderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderStatusRequest,
  ambassadorWixEcomV1OrderTypes.UpdateOrderStatusRequest,
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderStatusResponse &
    ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderStatusResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.UpdateOrderStatusResponse &
    ambassadorWixEcomV1OrderTypes.UpdateOrderStatusResponseNonNullableFields
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.updateOrderStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/{orderId}/update-status',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function aggregateOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.AggregateOrdersRequest,
  ambassadorWixEcomV1OrderTypes.AggregateOrdersRequest,
  ambassadorWixEcomV1OrderUniversalTypes.AggregateOrdersResponse,
  ambassadorWixEcomV1OrderTypes.AggregateOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Order.aggregateOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/aggregate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOrderTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrderTagsRequest,
  ambassadorWixEcomV1OrderTypes.BulkUpdateOrderTagsRequest,
  ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrderTagsResponse &
    ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrderTagsResponseNonNullableFields,
  ambassadorWixEcomV1OrderTypes.BulkUpdateOrderTagsResponse &
    ambassadorWixEcomV1OrderTypes.BulkUpdateOrderTagsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.bulkUpdateOrderTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/orders/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
